import {
  type BuyerTeamMember,
  type BuyerJoinRequest,
} from '@choco-admin/types';

import {
  useGetBuyerUsersQueryQuery,
  useGetRequestsToJoinQuery,
} from '../../../../../generated';

export const useBuyerTeam = (buyerId: string) => {
  const {
    data: teamData,
    loading: teamLoading,
    error: teamError,
    refetch: refetchTeam,
  } = useGetBuyerUsersQueryQuery({
    variables: { buyerId },
    skip: !buyerId,
    fetchPolicy: 'cache-and-network',
    errorPolicy: 'all',
  });

  const {
    data: requestsData,
    loading: requestsLoading,
    error: requestsError,
    refetch: refetchRequests,
  } = useGetRequestsToJoinQuery({
    variables: {
      buyerId,
      statusFilter: 'pending',
    },
    skip: !buyerId,
    fetchPolicy: 'cache-and-network',
    errorPolicy: 'all',
  });

  const buyer = teamData?.buyer;
  const teamMembers: BuyerTeamMember[] =
    buyer?.users?.edges?.map((edge) => ({
      ...edge.node,
      role: edge.role,
    })) || [];

  const requests: BuyerJoinRequest[] =
    (requestsData?.getRequestsToJoin?.__typename === 'RequestsToJoinConnection'
      ? requestsData.getRequestsToJoin.edges?.map((edge) => edge.node)
      : []) || [];

  return {
    // Team members
    teamMembers,
    teamLoading,
    teamError,
    refetchTeam,

    // Requests to join
    requests,
    requestsLoading,
    requestsError,
    refetchRequests,

    // Buyer info
    rolesEnabled: buyer?.rolesEnabled || false,

    // Loading states
    isLoading: teamLoading || requestsLoading,

    // Refetch all
    refetchAll: () => {
      refetchTeam();
      refetchRequests();
    },
  };
};
